import { useState } from "react";
import { useForm } from "react-hook-form";
import useFetch from "../../hooks/useFetch";
import { CreationCompte } from "../../services/Api/swagger";

interface CompteForm {
  numeroAdhesion: number;
  email: string;
}
export const useCreationCompte = () => {
  // ------------
  // INIT FORMULAIRE
  // ------------
  const methods = useForm<CompteForm>({
    mode: "onBlur",
    reValidateMode: "onBlur",
    criteriaMode: "all",
    defaultValues: {},
  });

  const {
    watch,
    handleSubmit,
    formState: { errors },
    register,
    setValue,
    clearErrors,
  } = methods;

  const [paramsCreationCompte, setParamsCreationCompte] = useState<
    CreationCompte | undefined
  >();
  const { response, fetching, error: errorApi } = useFetch<CreationCompte>(
    paramsCreationCompte,
    "postCompte",
    paramsCreationCompte && paramsCreationCompte.numeroAdhesion ? true : false
  );

  return {
    methods,
    watch,
    handleSubmit,
    errors,
    register,
    setValue,
    clearErrors,
    setParamsCreationCompte,
    response,
    fetching,
    errorApi,
  };
};
